module.exports = __webpack_public_path__ + "static/img/case_detail_03_3.2495144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_03_3.png
// module id = h/3s
// module chunks = 34